import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateSubTypeIsRequiredMutation } from './update-subtype-is-required.mutation';
export const { useSubscribableMutation: useUpdateSubTypeIsRequired, useSubscribeMutationResult: useUpdateSubTypeIsRequiredResult, } = createSubscribableMutator(UpdateSubTypeIsRequiredMutation);
